/**
 * 📮 개발요청 — /dev-plan (v2.274.0 · 2026-10-18 사용자 「작성된 건들은 지금의 개발계획 위치에 누적으로 게시」)
 *
 * 옛 「🧭 개발 계획」(v2.180.0 · admin 전용 메뉴별 계획 노트) 자리를 전 직원의 개발요청 게시판으로 바꿨다.
 *   주소는 그대로 둔다(즐겨찾기·옛 링크가 깨지지 않게) · 옛 계획 글은 사용자 지시로 지웠다.
 *   보기·쓰기 = 전 직원(조회 전용 포함 · 서버 /dev-requests 가드) · 상태 바꾸기 = 관리자.
 */

import { DevRequestBoard } from '../components/DevRequestBoard';

export function DevRequestPage() {
  return (
    <div className="p-8">
      <h1 className="ui-page-title">개발요청</h1>
      <p className="ui-page-sub mb-3">전 메뉴의 개발요청 · 🤖 검토 계획(답글) · 처리 상태</p>
      <DevRequestBoard />
    </div>
  );
}
